import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "sidebar-menu-set" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(['sidebar', { close: !_ctx.sidebarOpen }])
  }, [
    _createElementVNode("div", {
      class: "sidebar-icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
    }, [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "barr1" }, null, -1),
      _createElementVNode("div", { class: "barr2" }, null, -1),
      _createElementVNode("div", { class: "barr3" }, null, -1)
    ]))]),
    _createElementVNode("div", {
      class: "sidebar-icon close",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("div", { class: "barr1" }, null, -1),
      _createElementVNode("div", { class: "barr2" }, null, -1),
      _createElementVNode("div", { class: "barr3" }, null, -1)
    ]))]),
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: item.to,
          to: item.to
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(['sidebar-menu-animate', { active: _ctx.activeRoute === item.to || (!item.exact && _ctx.activeRoute.startsWith(item.to + '/')) }])
            }, [
              _createElementVNode("li", {
                class: _normalizeClass(['sidebar-menu', { active: _ctx.activeRoute === item.to || (!item.exact && _ctx.activeRoute.startsWith(item.to + '/')) }])
              }, [
                _createElementVNode("img", {
                  src: item.icon,
                  class: "sidebar-menu-icon",
                  alt: ""
                }, null, 8, _hoisted_2),
                _createElementVNode("span", null, _toDisplayString(item.label), 1)
              ], 2)
            ], 2)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ]),
    _renderSlot(_ctx.$slots, "widget", {}, undefined, true)
  ], 2))
}